import { ReactNode } from "react";

import { tw } from "~/utils";

interface MainLayoutProps {
  children: ReactNode;
  className?: string;
}

export const MainLayout = ({ children, className }: MainLayoutProps) => {
  return (
    <div
      className={tw(
        // Min height of screen, can grow and scroll if needed
        "flex min-h-screen flex-col items-center bg-pink-100",
        // Padding
        "px-2 py-4 sm:px-10 sm:py-8",
        className,
      )}
    >
      {children}
    </div>
  );
};
